import {AdapterProps, FieldAdapter} from '../field-factory';
import {PinInput as MantinePinInput, PinInputProps} from '@mantine/core';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $PinInputAdapterProps = AdapterProps<PinInputProps>;

export const $PinInputAdapter: FC<FieldAdapter<$PinInputAdapterProps>> = ({
  inputProps: {onChange, ...inputProps},
  control,
}) => {
  const {
    field: {onChange: fieldOnChange, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const {readOnly} = useContext(ReadOnlyContext);

  const _onChange: PinInputProps['onChange'] = (value) => {
    fieldOnChange(value);
    onChange?.(value);
  };

  return (
    <MantinePinInput
      error={invalid}
      disabled={readOnly}
      onChange={_onChange}
      {...fieldProps}
      {...inputProps}
    />
  );
};